export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/gankster-duos/id6755520323';
export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=gg.duos.app';
